
export const ALL_COUNTRIES = 'ALL_COUNTRIES';

export const FETCH_COUNTRY_DETAIL = "FETCH_COUNTRY_DETAIL";

export const ORDER_BY_POPULATION = "ORDER_BY_POPULATION"
export const FILTER_BY_CONTINENT = "FILTER_BY_CONTINENT"
export const SET_COUNTRY_ORDER = "SET_COUNTRY_ORDER"

 export const SET_ALL_COUNTRIES = "SET_ALL_COUNTRIES"

 export const FETCH_COUNTRIES_BY_NAME = 'FETCH_COUNTRIES_BY_NAME';

 export const CREATE_ACTIVITY = "CREATE_ACTIVITY"



 export const GET_ACTIVITIES = 'GET_ACTIVITIES';

 export const FILTER_COUNTRIES_BY_ACTIVITY = "FILTER_COUNTRIES_BY_ACTIVITY"
 
 